import _ from 'lodash';

/* @ngInject */
export default function EquipmentService(
  $q,
  $sails,
  $log,
  EquipmentInfoService,
  RcuInfoService,
) {
  const service = this;

  service.getEquipmentList = getEquipmentList;
  service.addEquipment = addEquipment;
  service.deleteEquipment = deleteEquipment;
  service.editEquipment = editEquipment;
  service.editNotificationConfigs = editNotificationConfigs;
  service.disableEvents = disableEvents;
  service.copyEquipmentNoteConfigs = copyEquipmentNoteConfigs;

  function getEquipmentList() {
    return $sails.get('/equipment/')
      .catch((error) => {
        $log.error('Error: ', error);
        return $q.reject(error.data);
      });
  }

  function copyEquipmentNoteConfigs(ids, eventNames, policy) {
    return $sails.put('/equipment/notificationConfigs/copy', { ids, eventNames, policy })
      .then(({ data: equipment }) => {
        equipment.forEach(eq => EquipmentInfoService.updateEquipment(eq));
        return equipment;
      })
      .catch((error) => {
        $log.error('Error: ', error);
        return $q.reject(error.data);
      });
  }

  /* TODO: There is currently no tie between this and the equipmentInfoService!
  ** (New equipment must be added manually to models)
  */
  function addEquipment(eqObject) {
    return $sails.post('/equipment/', eqObject)
      .catch((error) => {
        $log.error('Error: ', error);
        return $q.reject(error.data);
      });
  }

  function deleteEquipment(equipId) {
    return $sails.delete(`/equipment/${equipId}`)
      .then(async () => {
        const { rcu } = await EquipmentInfoService.getEquipmentById(equipId);
        RcuInfoService
          .getRcuById(rcu)
          .then(({ equipment }) => _.pull(equipment, equipId));
      })
      .catch((error) => {
        $log.error('Error: ', error);
        return $q.reject(error.data);
      });
  }

  function editEquipment(equipId, eqObject) {
    return $sails.put(`/equipment/${equipId}`, angular.fromJson(angular.toJson(eqObject)))
      .catch((error) => {
        $log.error('Error: ', error);
        return $q.reject(error.data);
      });
  }

  function editNotificationConfigs(eqObjects) {
    return $sails.put('/equipment/notificationConfigs', angular.fromJson(angular.toJson(eqObjects)))
      .then(({ data: [equipment] }) => {
        EquipmentInfoService.updateEquipment(equipment);
        return equipment;
      })
      .catch((error) => {
        $log.error('Error: ', error);
        return $q.reject(error.data);
      });
  }

  function disableEvents(equipmentIds, disableTime) {
    const eqIds = _.isArray(equipmentIds) ? equipmentIds.join('|') : equipmentIds;
    return $sails.put(`/equipment/eventDisable/${eqIds}`, { disableTime })
      .catch((error) => {
        $log.error('Error: ', error);
        return $q.reject(error.data);
      });
  }
}
